import { motion } from 'framer-motion';
import { actorInfo, bioText, skills } from '../../../mocks/portfolio';

const Bio = () => {
  return (
    <section id="bio" className="py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid md:grid-cols-5 gap-12 mb-16">
          {/* Portrait & Quick Facts */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="md:col-span-2"
          >
            <div className="w-full h-[400px] rounded-3xl overflow-hidden mb-6 shadow-xl">
              <img
                src="https://static.readdy.ai/image/7a4b9f6fb098032c02d4013b63a920f6/923eaa81bfcf170a4d5a63d70f1a9e8b.jpeg"
                alt={actorInfo.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <div className="text-gray-500 uppercase tracking-wider text-xs mb-1">Height</div>
                <div className="font-semibold text-gray-900">{actorInfo.height}</div>
              </div>
              <div>
                <div className="text-gray-500 uppercase tracking-wider text-xs mb-1">Location</div>
                <div className="font-semibold text-gray-900">{actorInfo.location}</div>
              </div>
              <div className="col-span-2">
                <div className="text-gray-500 uppercase tracking-wider text-xs mb-1">Representation</div>
                <div className="font-semibold text-gray-900">{actorInfo.representation}</div>
              </div>
            </div>
          </motion.div>

          {/* Narrative Bio */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="md:col-span-3"
          >
            <div className="inline-block px-4 py-1.5 border-2 border-burgundy text-burgundy rounded-full text-xs uppercase tracking-wider mb-6">
              About
            </div>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="font-serif text-lg">
                <span className="float-left font-serif text-7xl leading-none mr-3 text-burgundy">
                  A
                </span>
                {bioText.intro}
              </p>
              
              <p className="font-serif text-lg">{bioText.background}</p>
              
              <p className="font-serif text-lg">{bioText.recent}</p>
              
              <p className="font-serif text-lg">{bioText.approach}</p>
            </div>
          </motion.div>
        </div>

        {/* Skills & Training */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-16"
        >
          <h3 className="font-serif text-3xl font-semibold text-gray-900 mb-8 text-center">
            Skills &amp; Training
          </h3>
          
          <div className="flex overflow-x-auto gap-6 pb-4 scrollbar-hide">
            {skills.map((skill, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex-shrink-0 w-48 h-32 rounded-2xl bg-gradient-to-br from-burgundy to-red-900 p-6 flex flex-col justify-center items-center text-center shadow-lg"
              >
                <div className="font-bold text-xl text-white mb-2">{skill.category}</div>
                <div className="text-sm text-white/80 font-light">{skill.training}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Bio;